#!/usr/bin/env node
import { buildCLI } from '../cli.js';

buildCLI().parse(); 